<div class="container">
  <div class="headerContainer">
    <h1><b>SCHEDULE/RUN REPORTS</b></h1>
  </div>

  @let isRunning = isRunning$ | async;
  <div class="content-wrapper">
    <div class="content" [class.content-busy]="isRunning">

      <h3 class="section-label">RUN REPORTS</h3>
      <ag-grid-angular
        class="section-grid"
        [columnDefs]="templatesColDefs"
        [defaultColDef]="defaultColDef"
        [suppressCellFocus]="true"
        (gridReady)="onTemplatesGridReady($event)"
        [theme]="theme"
        [gridOptions]="sharedGridOptions"
        (cellClicked)="onTemplatesCellClicked($event)"
      />

      <h3 class="section-label">ORGANIZATIONAL REPORTS</h3>
      <ag-grid-angular
        class="section-grid"
        [columnDefs]="orgReportsColDefs"
        [defaultColDef]="defaultColDef"
        [suppressCellFocus]="true"
        (gridReady)="onOrgReportsGridReady($event)"
        [theme]="theme"
        [gridOptions]="sharedGridOptions"
        (cellClicked)="onOrgReportsCellClicked($event)"
      />

      <h3 class="section-label">SCHEDULED REPORTS</h3>
      <ag-grid-angular
        class="section-grid"
        [columnDefs]="schedulesColDefs"
        [defaultColDef]="defaultColDef"
        [suppressCellFocus]="true"
        (gridReady)="onSchedulesGridReady($event)"
        [theme]="theme"
        [gridOptions]="schedulesGridOptions"
        (cellClicked)="onSchedulesCellClicked($event)"
      />
      <div class="grid-footer">
        <mat-checkbox
          [checked]="(showInactiveSchedules$ | async) ?? false"
          (change)="onShowInactiveSchedulesChange($event.checked)"
          color="primary"
        >
          Show Inactive
        </mat-checkbox>
      </div>

    </div>

    @if (isRunning) {
      <div class="run-spinner-overlay">
        <mat-spinner diameter="48"></mat-spinner>
        <p class="run-spinner-text">Running report...</p>
      </div>
    }
  </div>
</div>
